import { Button, Stack } from '@mui/material'
import WarningRoundedIcon from '@mui/icons-material/WarningRounded'
import Alert from '@mui/material/Alert'
import useCheckMobileScreen from 'hooks/use-check-mobile-screen'
import { COLORS } from 'app-constants'

const RefreshAppAlert = () => {
  const isMobile = useCheckMobileScreen()

  const onRefreshClick = () => {
    window.location.reload()
  }

  return (
    <Stack
      position="absolute"
      top="24px"
      left="50%"
      zIndex={9999}
      px={isMobile ? 2 : 0}
      width={isMobile ? '100%' : 'fit-content'}
      sx={{
        transform: 'translate(-50%, 0)',
        alignItems: 'center',
        ' .MuiAlert-action': {
          padding: '0px 0 0 16px',
          alignItems: 'center',
        },
      }}>
      <Alert
        action={
          <Button
            color="inherit"
            size="small"
            onClick={onRefreshClick}
            sx={{
              color: COLORS.BROWN,
              padding: 0,
            }}>
            Refresh
          </Button>
        }
        icon={
          <WarningRoundedIcon
            sx={{
              marginBottom: '3px',
            }}
          />
        }
        severity="warning"
        sx={{
          color: COLORS.BROWN,
          backgroundColor: COLORS.ORANGE_10_PERCENT,
          alignItems: 'center',
        }}>
        Please refresh the page for the latest app version.
      </Alert>
    </Stack>
  )
}

export default RefreshAppAlert
